import { useQuery } from "@tanstack/react-query";
import { Clock, MapPin } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { api, imgSrc, WHATSAPP_URL } from "@/lib/api";
import type { Tour } from "@/types";

export default function Tours() {
  const { t, pick } = useLang();
  const { data: tours = [] } = useQuery<Tour[]>({ queryKey: ["tours"], queryFn: async () => (await api.get("/tours")).data });
  return (
    <div data-testid="tours-page">
      <section className="relative overflow-hidden grain">
        <img src="/images/t-isla.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0B192C] via-[#0B192C]/70 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 text-white">
          <p className="eyebrow !text-[#F3E5AB]">{t("tours.eyebrow")}</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl">{t("tours.title")}</h1>
          <p className="mt-5 max-w-lg text-white/80">{t("tours.sub")}</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20 space-y-16 sm:space-y-24">
        {tours.map((tour, i) => {
          const msg = encodeURIComponent(`Hola, me interesa: ${pick(tour, "title")}`);
          return (
            <article key={tour.id} data-testid={`tour-card-${tour.id}`} className={`grid gap-8 md:gap-14 md:grid-cols-2 items-center ${i % 2 ? "md:[&>*:first-child]:order-2" : ""}`}>
              <div className="aspect-[4/3] overflow-hidden rounded-xl">
                <img src={imgSrc(tour.image)} alt={pick(tour, "title")} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              </div>
              <div>
                <span className="font-display text-5xl text-[#00D2C8]/60">{String(i + 1).padStart(2, "0")}</span>
                <h2 className="mt-3 font-display text-3xl sm:text-4xl text-[#0B192C]">{pick(tour, "title")}</h2>
                <div className="mt-4 flex flex-wrap gap-5 text-sm text-slate-500">
                  {pick(tour, "duration") && <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-[#B8922A]" />{pick(tour, "duration")}</span>}
                  {tour.location && <span className="flex items-center gap-1.5"><MapPin className="h-4 w-4 text-[#B8922A]" />{tour.location}</span>}
                </div>
                <p className="mt-5 text-base leading-relaxed text-slate-600">{pick(tour, "desc")}</p>
                <a href={`${WHATSAPP_URL}?text=${msg}`} target="_blank" rel="noreferrer" data-testid={`tour-ask-btn-${tour.id}`}
                  className="mt-8 inline-flex items-center rounded-full border border-[#0B192C] px-6 py-3 text-sm font-semibold text-[#0B192C] transition-colors hover:bg-[#0B192C] hover:text-white">{t("tours.ask")}</a>
              </div>
            </article>
          );
        })}
      </section>
    </div>
  );
}
